import { TextColorType } from "@/lib/main";
import { CSSProperties, HTMLAttributes, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  className?: HTMLAttributes<HTMLHeadingElement>["className"];
  color?: TextColorType;
  fontWeight?: 500 | 600 | 700 | 800;
  id?: HTMLAttributes<HTMLHeadingElement>["id"];
  lineHeight?: number;
  size?: "sm" | "md" | "lg";
  textAlign?: CSSProperties["textAlign"];
}>;

export default function Heading1({
  children,
  className,
  color,
  fontWeight,
  id,
  lineHeight,
  size,
  textAlign,
}: Props) {
  const styles: CSSProperties = {
    color: `var(--color-text-${color || "primary"})`,
    fontSize: `var(--font-size-heading-1-${size || "lg"})`,
    fontWeight: fontWeight || 600,
    lineHeight: lineHeight || "var(--line-height-heading)",
    textAlign: textAlign || "start",
  };

  return (
    <h1 className={className} id={id} style={styles}>
      {children}
    </h1>
  );
}
